module.exports = "<ng-progress></ng-progress>\r\n<router-outlet></router-outlet>\r\n<p-growl life=\"4000\"></p-growl>"


//////////////////
// WEBPACK FOOTER
// C:/Users/LIVE02/Documents/SSW/ThanhBuoi/TBE_CRM/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main